// Treats Bundle + Subscribe UI (Shopify Selling Plans)
document.addEventListener('DOMContentLoaded', function () {
  const bundleCartForm = document.getElementById('bundleCartForm');

  // Popup elements
  const overlay = document.getElementById('bundlePopupOverlay');
  const dialog = overlay ? overlay.querySelector('.bundle-popup') : null;
  const closeBtn = document.getElementById('bundlePopupClose');
  const addTwoPoultryBtn = document.getElementById('addTwoPoultry');
  const addTwoFishBtn = document.getElementById('addTwoFish');
  const addMixedBtn = document.getElementById('addMixed');
  const subtitleEl = document.getElementById('bundlePopupSubtitle');

  // Choice preview elements
  const choice1Title = document.getElementById('choiceItem1Title');
  const choice1Qty = document.getElementById('choiceItem1Qty');
  const choice1Img = document.getElementById('choiceItem1Img');
  const choice2Title = document.getElementById('choiceItem2Title');
  const choice2Qty = document.getElementById('choiceItem2Qty');
  const choice2Img = document.getElementById('choiceItem2Img');

  // Subscription pill + summary
  const subPill = document.getElementById('bundleSubscribePill');
  const subFreq = document.getElementById('bundleSubscribeFreq');
  const choiceSummary = document.getElementById('bundleChoiceSummary');
  const bundlePopupProductTitle = document.getElementById('bundlePopupProductTitle');

  // Mixed bundle product no longer used for add; we will add two items directly
  const mixedVariantId = (window.treatsBundle && window.treatsBundle.bundleVariantId) || null; // kept for potential future use

  let availableProducts = [];
  let lastClickedProduct = null;
  let pendingForm = null;
  let lastTrigger = null;
  let selectedProduct1 = null; // Currently selected product for first card
  let selectedProduct2 = null; // Currently selected product for second card

  // ---------------- Subscription mode state (set when opening popup from a subscribed card)
  let pendingSubscription = false;
  let pendingSubscriptionPlanLabel = null;

  // ---------------- Helpers
  // Ensure overlay is attached to <body> to avoid transformed ancestor clipping
  if (overlay && overlay.parentElement !== document.body) {
    try { document.body.appendChild(overlay); } catch (e) { /* no-op */ }
  }

  function cleanType(title) {
    const lower = (title || '').toLowerCase();
    if (lower.includes('poultry')) return 'Poultry';
    if (lower.includes('chicken')) return 'Chicken';
    if (lower.includes('duck')) return 'Duck';
    if (lower.includes('turkey')) return 'Turkey';
    if (lower.includes('lamb')) return 'Lamb';
    if (lower.includes('beef')) return 'Beef';
    if (lower.includes('salmon')) return 'Salmon';
    if (lower.includes('fish')) return 'Fish';
    return (title || '').split(' ')[0] || 'Item';
  }

  function getTypeFromProduct(productObj) {
    const d = productObj?.element?.dataset?.productType;
    return (d && d.trim()) ? d.trim() : cleanType(productObj?.title);
  }

  function planText(selectEl) {
    return selectEl?.selectedOptions?.[0]?.text?.trim() || '';
  }

  function normalizePlanLabel(label) {
    return (label || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function extractDigits(label) {
    const m = (label || '').toString().match(/\d+/g);
    return m ? m.join('') : '';
  }

  function pickSellingPlanForProduct(productObj, desiredLabel) {
    // productObj.planOptions: [{ text, value }]
    const options = Array.isArray(productObj?.planOptions) ? productObj.planOptions : [];
    if (!options.length) return null;

    const desiredNorm = normalizePlanLabel(desiredLabel);
    if (desiredNorm) {
      // 1) Exact-ish match on normalized label
      const exact = options.find(o => normalizePlanLabel(o.text) === desiredNorm);
      if (exact?.value) return { id: exact.value, label: exact.text };

      // 2) Match by any shared digits (e.g., "30 days")
      const desiredDigits = extractDigits(desiredNorm);
      if (desiredDigits) {
        const digitMatch = options.find(o => extractDigits(o.text) === desiredDigits);
        if (digitMatch?.value) return { id: digitMatch.value, label: digitMatch.text };
      }
    }

    // Fallback: product default, then first option
    if (productObj?.defaultSellingPlanId) {
      const opt = options.find(o => String(o.value) === String(productObj.defaultSellingPlanId));
      return { id: productObj.defaultSellingPlanId, label: opt?.text || productObj.defaultSellingPlanLabel || '' };
    }

    const first = options[0];
    return first?.value ? { id: first.value, label: first.text } : null;
  }

  function setChoicePreview(product1, product2) {
    selectedProduct1 = product1;
    selectedProduct2 = product2;
    
    // Update first card
    if (choice1Title) choice1Title.textContent = getTypeFromProduct(product1);
    if (choice1Qty) choice1Qty.textContent = 'x1';
    if (choice1Img && product1.image) {
      choice1Img.src = product1.image;
      choice1Img.alt = getTypeFromProduct(product1);
    }
    const card1 = document.getElementById('choiceItem1');
    if (card1) card1.dataset.productType = getTypeFromProduct(product1).toLowerCase();

    // Update second card
    if (choice2Title) choice2Title.textContent = getTypeFromProduct(product2);
    if (choice2Qty) choice2Qty.textContent = 'x1';
    if (choice2Img && product2.image) {
      choice2Img.src = product2.image;
      choice2Img.alt = getTypeFromProduct(product2);
    }
    const card2 = document.getElementById('choiceItem2');
    if (card2) card2.dataset.productType = getTypeFromProduct(product2).toLowerCase();
    
    // Update dynamic title
    updateBundleTitle(product1, product2);
  }

  function updateBundleTitle(product1, product2) {
    if (!bundlePopupProductTitle || !product1 || !product2) return;
    
    const type1 = getTypeFromProduct(product1).toUpperCase();
    const type2 = getTypeFromProduct(product2).toUpperCase();
    
    let titleText = '';
    if (type1 === type2) {
      titleText = `Two ${type1}`;
    } else {
      titleText = `${type1} + ${type2}`;
    }
    
    bundlePopupProductTitle.textContent = titleText;
  }

  function swapProduct(cardElement) {
    if (!selectedProduct1 || !selectedProduct2) return;
    
    const cardId = cardElement.id;
    const otherProduct = availableProducts.find(p => {
      const currentType = cardId === 'choiceItem1' ? getTypeFromProduct(selectedProduct1) : getTypeFromProduct(selectedProduct2);
      return getTypeFromProduct(p).toLowerCase() !== currentType.toLowerCase();
    });
    
    if (!otherProduct) return;
    
    if (cardId === 'choiceItem1') {
      setChoicePreview(otherProduct, selectedProduct2);
    } else {
      setChoicePreview(selectedProduct1, otherProduct);
    }
  }

  function getPoultryProduct() {
    return availableProducts.find(p => getTypeFromProduct(p).toLowerCase().includes('poultry')) || availableProducts[0];
  }

  function getFishProduct() {
    return availableProducts.find(p => getTypeFromProduct(p).toLowerCase().includes('fish')) || availableProducts[1] || availableProducts[0];
  }

  function getFocusable(root) {
    if (!root) return [];
    return [...root.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    )].filter(el => !el.hasAttribute('disabled'));
  }

  function openPopup(triggerEl, defaultMode = 'mixed') {
    if (!overlay || !dialog) return;
    
    // If no lastClickedProduct (e.g., from cart page), use first two available products
    if (!lastClickedProduct && availableProducts.length >= 2) {
      lastClickedProduct = availableProducts[0];
    }
    
    if (!lastClickedProduct || availableProducts.length < 2) return;
    
    const otherProduct = availableProducts.find(p => p.id !== lastClickedProduct.id) || availableProducts[1];
    if (!otherProduct) {
      if (pendingForm) { pendingForm.submit(); pendingForm = null; }
      return;
    }

    // Initialize with clicked product and other product
    setChoicePreview(lastClickedProduct, otherProduct);

    // Subscription pill is not shown in popup since subscription is handled via buttons
    if (subPill) subPill.hidden = true;

    lastTrigger = triggerEl || document.activeElement;
    overlay.classList.add('active');
    document.body.classList.add('modal-open');

    setTimeout(() => {
      const first = getFocusable(dialog)[0];
      (first || dialog)?.focus?.();
    }, 0);

    overlay.addEventListener('keydown', onKeydown);
  }
  
  // Expose openPopup globally for cart page
  window.openBundlePopup = openPopup;

  function closePopup() {
    overlay?.classList.remove('active');
    document.body.classList.remove('modal-open');
    overlay?.removeEventListener('keydown', onKeydown);
    if (lastTrigger?.focus) lastTrigger.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); closePopup(); }
  }

  // ---------------- Init product cards
  function initializeProducts() {
    availableProducts = [];
    
    // Check if we're on cart page and have cartTreatsData
    if (window.cartTreatsData && window.cartTreatsData.treats && window.cartTreatsData.treats.length >= 2) {
      // Initialize from cart page data
      const cartTreatCards = document.querySelectorAll('.cart-treat-card');
      window.cartTreatsData.treats.forEach((treat, index) => {
        // Get image from cart treat cards if available, otherwise use treat.image from data
        let treatImage = treat.image || null;
        if (!treatImage && cartTreatCards[index]) {
          const img = cartTreatCards[index].querySelector('.cart-treat-image');
          if (img) {
            treatImage = img.src;
          }
        }
        
        availableProducts.push({
          id: treat.variantId, // Using variantId as ID for cart page
          variantId: treat.variantId,
          title: treat.title,
          image: treatImage,
          element: null,
          sellingPlans: treat.sellingPlans || []
        });
      });
      
      return; // Exit early, products initialized from cart data
    }
    
    // Original initialization from product cards
    document.querySelectorAll('.treat-product-card').forEach(card => {
      const productId = card.dataset.productId;
      const variantInput = card.querySelector('input[data-variant-id]');
      const titleEl = card.querySelector('.treat-title');
      const imgEl = card.querySelector('.treat-image');
      if (!productId || !variantInput || !titleEl) return;

      // Capture selling plan options for this product (label -> id)
      const planSelectEl = card.querySelector(`#selling-plan-${productId}`);
      const planOptions = [];
      let defaultSellingPlanId = null;
      let defaultSellingPlanLabel = null;
      if (planSelectEl) {
        const opts = [...planSelectEl.querySelectorAll('option')];
        opts.forEach(opt => {
          planOptions.push({ text: (opt.textContent || '').trim(), value: opt.value });
        });
        const selectedOpt = planSelectEl.selectedOptions?.[0] || opts[0] || null;
        if (selectedOpt?.value) {
          defaultSellingPlanId = selectedOpt.value;
          defaultSellingPlanLabel = (selectedOpt.textContent || '').trim();
        }
      }

      const productObj = {
        id: productId,
        variantId: variantInput.dataset.variantId,
        title: titleEl.textContent.trim(),
        image: imgEl ? imgEl.src : null,
        element: card,
        planOptions,
        defaultSellingPlanId,
        defaultSellingPlanLabel
      };
      availableProducts.push(productObj);

      // Wire up toggle for this product
      wireSubscribeToggle(card);
    });
  }

  // ---------------- Wire up toggle switch
  function wireSubscribeToggle(card) {
    const pid = card.dataset.productId;
    const toggle = card.querySelector(`#subscribe-${pid}`);
    const subscribeText = card.querySelector(`#subscribe-text-${pid}`);
    const subscribeHelpText = card.querySelector(`#subscribe-help-text-${pid}`);
    const planSelect = card.querySelector(`#selling-plan-${pid}`);
    const planInput = card.querySelector(`#selling-plan-input-${pid}`);
    const addToCartBtn = card.querySelector('.add-to-cart-btn-one-time');
    const purchaseBox = card.querySelector('.purchase-options-box');
    const subscribeInfo = card.querySelector(`#subscribe-info-${pid}`);
    
    if (!toggle) return;
    
    const updateUI = () => {
      const isSubscribed = toggle.checked;
      
      // Add/remove class to purchase box for CSS styling
      if (purchaseBox) {
        if (isSubscribed) {
          purchaseBox.classList.add('subscription-active');
        } else {
          purchaseBox.classList.remove('subscription-active');
        }
      }
      
      // Add/remove class to purchase switch for CSS styling
      const purchaseSwitch = card.querySelector('.purchase-switch');
      if (purchaseSwitch) {
        if (isSubscribed) {
          purchaseSwitch.classList.add('subscription-active');
        } else {
          purchaseSwitch.classList.remove('subscription-active');
        }
      }
      
      // Add/remove class to subscribe info for CSS styling
      if (subscribeInfo) {
        if (isSubscribed) {
          subscribeInfo.classList.add('subscription-active');
        } else {
          subscribeInfo.classList.remove('subscription-active');
        }
      }
      
      // Update main text
      if (subscribeText) {
        if (isSubscribed) {
          subscribeText.textContent = '✨ Subscribe & Save';
        } else {
          subscribeText.textContent = 'One-time purchase';
        }
      }
      
      // Update help text
      if (subscribeHelpText) {
        if (isSubscribed) {
          subscribeHelpText.textContent = 'Save & get regular deliveries when you subscribe. Never run out & save time!';
        } else {
          subscribeHelpText.textContent = 'Save & get regular deliveries when you subscribe.';
        }
      }
      
      // Update button color based on subscription state
      if (addToCartBtn) {
        if (isSubscribed) {
          addToCartBtn.classList.add('subscribed');
      } else {
          addToCartBtn.classList.remove('subscribed');
        }
      }
      
      // Update selling plan input
      if (planInput && planSelect) {
        if (isSubscribed && planSelect.value) {
          planInput.value = planSelect.value;
        } else {
          planInput.value = '';
        }
      }
    };
    
    // Set initial state
    updateUI();
    
    // Listen for changes
    toggle.addEventListener('change', updateUI);
  }

  // ---------------- Add to cart
  function addBundleToCart(product1, product2) {
    if (!product1 || !product2) return;
    
    const item1 = document.getElementById('bundleItem1');
    const item2 = document.getElementById('bundleItem2');
    const plan1 = document.getElementById('bundlePlan1');
    const plan2 = document.getElementById('bundlePlan2');
    const qty2  = bundleCartForm?.querySelector('input[name="items[1][quantity]"]');

    // Set variant IDs
    item1.value = product1.variantId;
    item2.value = product2.variantId;

    // Ensure second item fields are enabled
    if (item2) item2.disabled = false;
    if (plan2) plan2.disabled = false;
    if (qty2) qty2.disabled = false;

    // Apply subscription selling plans if opened from a subscribed card; otherwise one-time.
    if (pendingSubscription) {
      const pick1 = pickSellingPlanForProduct(product1, pendingSubscriptionPlanLabel);
      const pick2 = pickSellingPlanForProduct(product2, pendingSubscriptionPlanLabel || pick1?.label);

      if (plan1) plan1.value = pick1?.id || '';
      if (plan2) plan2.value = pick2?.id || '';

      // Update subscribe pill in popup (nice-to-have)
      if (subPill) subPill.hidden = false;
      if (subFreq) subFreq.textContent = (pick1?.label || pick2?.label || '').trim() || '—';
    } else {
      if (plan1) plan1.value = '';
      if (plan2) plan2.value = '';
      if (subPill) subPill.hidden = true;
    }

    bundleCartForm.submit();
    closePopup();
  }

  function addIndividualToCart() {
    pendingForm?.submit();
    pendingForm = null;
    closePopup();
  }

  // ---------------- AJAX Add to Cart function
  async function addToCartAjax(variantId, quantity, sellingPlanId = null) {
    // Validate inputs
    if (!variantId) {
      throw new Error('Variant ID is required');
    }
    
    const formData = {
      id: variantId,
      quantity: quantity || 1
    };
    
    if (sellingPlanId) {
      formData.selling_plan = sellingPlanId;
    }
    
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error('Cart API error:', errorText);
        throw new Error(`Failed to add to cart: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('Item added to cart:', data);
      
      // Update cart count badge
      await updateCartCount();
      
      // Navigate to cart page
      navigateToCart();
      
      return data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      // Fallback to form submission if AJAX fails
      throw error;
    }
  }

  // Update cart count badge
  async function updateCartCount() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const cartLink = document.querySelector('.site-header__cart');
      
      if (!cartLink) {
        console.warn('Cart link not found');
        return;
      }
      
      let cartCountEl = document.getElementById('CartCount');
      
      if (cart.item_count > 0) {
        // Create badge if it doesn't exist
        if (!cartCountEl) {
          cartCountEl = document.createElement('div');
          cartCountEl.id = 'CartCount';
          cartCountEl.className = 'site-header__cart-count';
          cartLink.appendChild(cartCountEl);
        }
        
        // Update count
        let countSpan = cartCountEl.querySelector('span');
        if (!countSpan) {
          countSpan = document.createElement('span');
          cartCountEl.appendChild(countSpan);
        }
        countSpan.textContent = cart.item_count;
        
        // Ensure badge is visible
        cartCountEl.style.display = 'flex';
      } else {
        // Hide badge if cart is empty
        if (cartCountEl) {
          cartCountEl.style.display = 'none';
        }
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  // Navigate to cart page
  function navigateToCart() {
    // Small delay to ensure cart is updated before navigation
    setTimeout(() => {
      window.location.href = '/cart';
    }, 100);
  }

  // ---------------- Event handlers
  // Handle Add to Cart (one-time) buttons
  document.querySelectorAll('.add-to-cart-btn-one-time').forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const form = this.closest('.individual-add-form');
      const card = form?.closest('.treat-product-card');
      const hiddenQty = form?.querySelector('input[name="quantity"]');
      const pid = card?.dataset.productId;
      const planInput = form?.querySelector(`#selling-plan-input-${pid}`);
      const toggle = card?.querySelector(`#subscribe-${pid}`);
      const planSelect = card?.querySelector(`#selling-plan-${pid}`);
      const variantInput = form?.querySelector('input[name="id"]');
      
      // Quantity is always 1 (hidden input defaults to 1)
      const quantity = hiddenQty ? parseInt(hiddenQty.value) || 1 : 1;
      
      // Check if subscribed (toggle is checked)
      const isSubscribed = toggle?.checked || false;
      
      if (isSubscribed) {
        // If subscribed, show bundle popup (and mark subscription mode)
        pendingSubscription = true;
        pendingSubscriptionPlanLabel = planText(planSelect) || null;

        lastClickedProduct = availableProducts.find(p => p.id === card?.dataset.productId) || null;
        pendingForm = form;
        openPopup(form, 'mixed');
      } else {
        // One-time mode
        pendingSubscription = false;
        pendingSubscriptionPlanLabel = null;

        // If one-time purchase, add via AJAX
        if (!variantInput) {
          console.error('Variant ID not found');
          alert('Error: Product variant not found. Please try again.');
          return;
        }
        
        const variantId = variantInput.value;
        const sellingPlanId = null; // One-time purchase
        
        if (!variantId) {
          console.error('Variant ID is empty');
          alert('Error: Invalid product variant. Please try again.');
          return;
        }
        
        // Disable button during request
        const originalText = this.textContent;
        this.disabled = true;
        this.textContent = 'Adding...';
        
        try {
          await addToCartAjax(variantId, quantity, sellingPlanId);
          // Success - button will be re-enabled and message shown
          this.textContent = originalText;
          this.disabled = false;
        } catch (error) {
          // Fallback to form submission
          console.error('AJAX add to cart failed, falling back to form submission:', error);
          this.textContent = originalText;
          this.disabled = false;
          
          // Clear selling plan for one-time purchase
          if (planInput) {
            planInput.value = '';
          }
          // Submit form as fallback
          form.submit();
        }
      }
    });
  });
  
  // Handle regular Add to Cart buttons (for products without selling plans)
  document.querySelectorAll('.individual-add-form .add-to-cart-btn').forEach(form => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const card = this.closest('.treat-product-card');
      const hiddenQty = this.querySelector('input[name="quantity"]');
      
      // Quantity is always 1 (hidden input defaults to 1)
      if (hiddenQty) {
        hiddenQty.value = '1';
      }

      // Always show bundle popup for single item (quantity is always 1)
      pendingSubscription = false;
      pendingSubscriptionPlanLabel = null;

      lastClickedProduct = availableProducts.find(p => p.id === card?.dataset.productId) || null;
      pendingForm = this;
      openPopup(this, 'mixed');
    });
  });

  // Swap button handlers (using event delegation)
  overlay?.addEventListener('click', function(e) {
    if (e.target.closest('.choice-swap-btn')) {
      e.stopPropagation();
      e.preventDefault();
      const card = e.target.closest('.choice-card');
      if (card) {
        swapProduct(card);
      }
    }
  });

  // Bundle button handlers
  closeBtn?.addEventListener('click', closePopup);
  
  // Add to cart button (adds current selection)
  const addToCartBtn = document.getElementById('addToCartFromPopup');
  addToCartBtn?.addEventListener('click', () => {
    if (selectedProduct1 && selectedProduct2) {
      addBundleToCart(selectedProduct1, selectedProduct2);
    }
  });
  
  addTwoPoultryBtn?.addEventListener('click', () => {
    const poultry = getPoultryProduct();
    if (poultry) {
      addBundleToCart(poultry, poultry);
    }
  });
  
  addTwoFishBtn?.addEventListener('click', () => {
    const fish = getFishProduct();
    if (fish) {
      addBundleToCart(fish, fish);
    }
  });
  
  addMixedBtn?.addEventListener('click', () => {
    const poultry = getPoultryProduct();
    const fish = getFishProduct();
    if (poultry && fish) {
      addBundleToCart(poultry, fish);
    }
  });

  overlay?.addEventListener('mousedown', e => {
    if (dialog && !dialog.contains(e.target)) closePopup();
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && overlay?.classList.contains('active')) closePopup();
  });

  // ---------------- Init
  initializeProducts();
});
